
import { computed, watchEffect, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

export default {
	name: 'FindYourMatch',
	setup() {
		const store = useStore();
		const currentlyLoading = ref(false);

		const questions = computed(() => {
			let questionsEl = document.querySelector('.js-find-your-match');
			const questionsValue = questionsEl.getAttribute('data-questions');
			if (questionsEl && questionsValue) {
				return JSON.parse(questionsValue);
			} else {
				return [];
			}
		});


		const forwardToPage = () => {
			currentlyLoading.value = true;
			const values = Object.values(store.state.q).join('');

			// Create an object to store the frequency of each character in the string
			const frequency = {};

			// Iterate over each character in the string and increment its frequency count in the frequency object
			for (const char of values) {
				frequency[char] = (frequency[char] || 0) + 1;
			}

			// Find the character with the highest frequency count in the frequency object
			let mostFrequentChar = '';
			let highestFrequency = 0;
			for (const char in frequency) {
				if (frequency[char] > highestFrequency) {
					mostFrequentChar = char;
					highestFrequency = frequency[char];
				}
			}

			const countryAndLanguage = () => {
				let countryString = document.querySelector('meta[property="og:site_name"]').getAttribute('content');
				let country = countryString.length ? countryString.substring(countryString.length - 2).toLowerCase() : 'us';
				let language = document.body.getAttribute('data-language');
				return [country, language];
			}


			let englishUrl = "pleaser";
			let spanishUrl = "los-anfitriones";
			let mexicoUrl = "los-complacientes";
			let portugueseUrl = "agradavel"
			switch (mostFrequentChar) {
				case 'A':
					englishUrl = "pleaser";
					spanishUrl = "los-anfitriones";
					mexicoUrl = "los-complacientes";
					portugueseUrl = "agradavel";
					break;
				case 'H':
					englishUrl = "family-cook";
					spanishUrl = "los-hogarenos";
					mexicoUrl = "los-familiares";
					portugueseUrl = "cozinheiro-de-familia"
					break;
				case 'D':
					englishUrl = "healthy-cook";
					spanishUrl = "los-deportistas";
					mexicoUrl = "los-saludables";
					portugueseUrl = "cozinheiro-saudavel"
					break;
				case 'C':
					englishUrl = "chef";
					spanishUrl = "los-chef";
					mexicoUrl = "los-chefs";
					portugueseUrl = "chefe-de-cozinha"
					break;
				case 'R':
					englishUrl = "indulgent";
					spanishUrl = "los-reposteros";
					mexicoUrl = "los-reposteros";
					portugueseUrl = "indulgente"
					break;
				case 'P':
					englishUrl = "grillmaster";
					spanishUrl = "los-parrilleros";
					mexicoUrl = "los-parrilleros";
					portugueseUrl = "churrasqueiro"
					break;
				default:
					englishUrl = "pleaser";
					spanishUrl = "los-anfitriones";
					mexicoUrl = "los-complacientes";
					portugueseUrl = "agradavel"
					break;
			}

			let country = countryAndLanguage()[0];
			let lang = countryAndLanguage()[1];

			if(country === `us`) {
				if(lang === `en`) {
					window.location.href = `/en-us/inspiration/find-your-match/${englishUrl}`;
				} else if(lang === 'es') {
					window.location.href = `/inspiracion/tu-producto-ideal/${spanishUrl}`;
				}
			} else if(country === `co`) {
				window.location.href = `/co/inspiracion/tu-producto-ideal/${spanishUrl}`;
			} else if(country === `mx`) {
				window.location.href = `/mx/inspiracion/tu-producto-ideal/${mexicoUrl}`;
			} else if(country === `br`) {
				window.location.href = `/br/inspiracao/encontre-seu-par/${portugueseUrl}`
			}else if (country === `pe`) {
				window.location.href = `/pe/inspiracion/tu-producto-ideal/${spanishUrl}`;
			}else if (country === `ec`) {
				window.location.href = `/ec/inspiracion/tu-producto-ideal/${spanishUrl}`;
			}else if (country === `do`) {
				window.location.href = `/do/inspiracion/tu-producto-ideal/${mexicoUrl}`;
			}else if (country === `ar`) {
				window.location.href = `/ar/inspiracion/tu-producto-ideal/${spanishUrl}`;
			}
		};

		const handlePopstate = (event) => {
			store.commit('updateActiveQuestion', 1);
		};

		const setValueAndProgress = async(value, index) => {
			let newIndex = index + 1;
			await store.commit(`updateQ${newIndex}`, value);
			await store.commit('updateActiveQuestion', newIndex+1);
			//if were at the end of the quiz send them where they need to go
			if((store.state.activeQuestion) === 4) {
				forwardToPage();
			}
		}

		watchEffect(() => {
			window.onpopstate = () => {
				questions.value
			}
		})

		return {
			store,
			questions,
			currentlyLoading,
			setValueAndProgress,
		};
	}
};
